import React from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Menu, Button } from "antd";
import MediaQuery from "react-responsive";
import { FormLabel, Row, Col } from "react-bootstrap";
import { labels } from "../../../localization/labels";

const { SubMenu } = Menu;

let subMenuIndex = 1;

const createMenu = menuItems => {
  return menuItems.map(menuItem => {
    const icon = menuItem.icon !== undefined ? menuItem.icon : null;
    if (menuItem.content !== undefined) {
      const keyValue = "sub_" + subMenuIndex++;
      return (
        <SubMenu
          key={keyValue}
          title={
            <span>
              {icon}
              <span>{menuItem.label}</span>
            </span>
          }
          popupClassName="menu-popup"
        >
          {createMenu(menuItem.content)}
        </SubMenu>
      );
    } else {
      const title = menuItem.label;
      return (
        <Menu.Item key={menuItem.key} title={title}>
          {icon}
          <span>{title}</span>
        </Menu.Item>
      );
    }
  });
};

const SideMenu = ({
  collapsed,
  menuItems,
  onMenuItemClick,
  location,
  onSideMenuToggle
}) => {
  subMenuIndex = 1;
  const menu = createMenu(menuItems);

  return (
    <>
      <MediaQuery minWidth={1024}>
        <div
          className={collapsed ? "menucontainer-collapsed" : "menucontainer"}
        >
          <Row className="sidemenu_container">
            <Col sm={collapsed ? "5" : "9"}>
              <FormLabel className="navbar-label">
                {collapsed
                  ? labels.applicationNameShort
                  : labels.applicationNameLong}
              </FormLabel>
            </Col>
            <Col sm={collapsed ? "7" : "3"}>
              <Button
                type="link"
                onClick={onSideMenuToggle}
                size="large"
                className="sidemenu-toggle_btn"
              >
                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              </Button>
            </Col>
          </Row>
          <Menu
            defaultSelectedKeys={[location.pathname]}
            mode="inline"
            theme="dark"
            inlineCollapsed={collapsed}
            onClick={item => {
              onMenuItemClick({ key: item.key, label: item.item.props.title });
            }}
          >
            {menu}
          </Menu>
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={1024}>
        <div className={"menucontainer-collapsed"}>
          <Menu
            defaultSelectedKeys={[location.pathname]}
            mode="inline"
            theme="dark"
            inlineCollapsed="true"
            onClick={item => {
              onMenuItemClick({ key: item.key, label: item.item.props.title });
            }}
          >
            {menu}
          </Menu>
        </div>
      </MediaQuery>
    </>
  );
};

export default SideMenu;
